import { MainLayout } from "~/components";
import { useEffect } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Definition } from "./DLADefinition";
import Box from "@material-ui/core/Box";
import { Includes } from "./DlaIncludes";
import { Chips } from "./DLAChips";
import { DLABG } from "~/assets";
import { line } from "~/assets";
import { Category } from "./Categories";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${DLABG})`,
    backgroundRepeat:"no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize:"120% auto",
    
    // backgroundImage: `url(${DLABG})`,
    // backgroundRepeat: "no-repeat",
    // backgroundPosition: "bottom right",
    // backgroundSize:'140%',
    // paddingBottom:'300px',

    [theme.breakpoints.up('lg')]:{
      // backgroundPosition: "right bottom",
      backgroundSize:'80% auto',
      // paddingBottom: '0px'
    },
    [theme.breakpoints.up('xl')]:{
      // backgroundPosition: "right bottom",
      backgroundSize:'65% auto',
      // paddingBottom: '0px'
    },
    // height: 1500,
    // width: 1000,
  },

  background:{
    backgroundImage: `url(${DLABG})`,
    backgroundRepeat:"no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize:"auto"
  } 
}));

export const Maindla = () => {
  const classes = useStyles();
  return (
    <Box width="100%" display="flex" flexDirection="column" alignItems="center" paddingBottom={{xs:30}} className={classes.root}>
      <Box maxWidth="1440px" width='100%'>

      
        <Box marginX={{ xs: 2, lg: 20, xl:0 }} mt={10}>
          <Definition />
          <Box display="flex" justifyContent="center" alignItems="center">
            <img src={line} alt="line" width="100%"></img>
          </Box>
        </Box>

        <Box mb={0}>
          <Box
            // bgcolor="red"
            display="flex"
            flexDirection="column"
            // marginTop={10}
            paddingY={15}
            marginX={{ xs: 2, lg: 20, xl:0 }}
            // bgcolor="red"
            // justifyContent={"space-between"}
            // // al={"space-between"}
            height="100%"
          >
            <Box
              display="flex"
              flexDirection="column"
              // bgcolor="red"
              height="100%"
              justifyContent="space-between"
            >
              <Box>
                <Includes />
              </Box>
              <Category />
            </Box>
          </Box>
        </Box>


      </Box>

    </Box>
  );
};
